import React, { useRef, useState } from 'react'
import { Button, Form} from 'react-bootstrap';
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle';
import axios from 'axios';
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { useTranslation } from 'react-i18next';

const DashboardEditSingleProduct = (props) => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const [product, setProduct] = useState({
        name: props.data.product.name ,
        brand: props.data.product.brand ,
        price: props.data.product.price ,
        sell_price: props.data.product.sell_price ,
        category_id: props.data.product.category_id
    })
    const {t} = useTranslation();

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    const changeHandler = event => {
        setProduct({ ...product, [event.target.name]: event.target.value })
    }

    const setUserNewInfo = (e)  => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            setBtnLoading(false)
            axios.put(`co/product/${props.data.product.id}`, product)
            .then(response => {
                toast.dismiss()
                toast.success(t("toast_successfully_edited") , {position: 'bottom-right',className: 'foo-bar'})
                props.update()
            })
            .catch(err => {
                console.log(err)
            })
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    return (
        <>
            <DashboardMainTitle> {t("edit")} {props.data.product.name} </DashboardMainTitle>
            <Form onSubmit={setUserNewInfo} className="col-md-12">
                <Form.Group className="mb-3 col-md-7" controlId="name">
                    <Form.Label>{t("title")} : </Form.Label>
                    <Form.Control  type="text"  name="name" value={product.name} onChange={changeHandler} />
                    <span className='validator_error'>{validator.current.message('name', product.name, 'required')}</span>
                </Form.Group>

                <Form.Group className="mb-3 col-md-7" controlId="brand">
                    <Form.Label> {t("brand")} : </Form.Label>
                    <Form.Control  type="text"  name="brand" value={product.brand} onChange={changeHandler} />
                    <span className='validator_error'>{validator.current.message('brand', product.brand, 'required')}</span>
                </Form.Group>

                <Form.Group className="mb-3 col-md-7" controlId="price">
                    <Form.Label> {t("product_price")} : </Form.Label>
                    <Form.Control type="text" name="price" value={product.price} onChange={changeHandler} />
                    <span className='validator_error'>{validator.current.message('price', product.price, 'required')}</span>
                </Form.Group>

                <Form.Group className="mb-3 col-md-7" controlId="sell_price">
                    <Form.Label> {t("product_selling_price")} : </Form.Label>
                    <Form.Control type="text" name="sell_price" value={product.sell_price} onChange={changeHandler} />
                    <span className='validator_error'>{validator.current.message('sell_price', product.sell_price, 'required')}</span>
                </Form.Group>

                <div className='d-flex justify-content-end'>
                    <Button variant="primary" type="submit" className="btn btn-success mt-3 mx-1" disabled={btnLoading ? true : false} >
                        {t("edit")}
                    </Button>
                    <Button variant="primary" type="button" className="btn btn-secondary mt-3" onClick={props.closeEdit} >
                        {t("Cancel")}
                    </Button>
                </div>
            </Form> 
        </>
    )
}

export default DashboardEditSingleProduct
